export const ANIMATION_DURATION = 300;

/* Declared on css */
export const MARGIN_SIZE = 10;
export const MIN_SLIDES = 2;
export const MAX_SLIDES = 6;
export const RECOMMENDED_LIMIT = 4;
